import { Box, Flex } from '@chakra-ui/react';

import { ButtonIcon } from 'shared';
import { Icon, iconNames } from 'shared_DEPRECATED/components/Icon';
import Spacer from 'shared_DEPRECATED/components/Spacer';
import { Attachment } from 'shared_DEPRECATED/types/Attachment';

import { ChatScrollToMessage } from '../../ChatScrollToMessage';
import { ChatFormAttachmentReply } from './AttachmentReply';
import { ChatFormReplyTo } from './ReplyTo';

type MessageReplyProps = {
  onCancel: () => void;
  messageId: string;
  name: string;
  text?: string;
  attachments?: Attachment[];
};

export const ChatFormMessageReply = ({
  onCancel,
  text,
  name,
  messageId,
  attachments,
}: MessageReplyProps) => {
  return (
    <Flex>
      <Box w="3px" bg="var(--bgCompAccent)" />
      <Spacer size="sm" />
      <Flex w="100%" justifyContent="space-between">
        <Flex direction="column">
          <ChatScrollToMessage messageId={messageId}>
            <ChatFormReplyTo name={name}>{text}</ChatFormReplyTo>
          </ChatScrollToMessage>
          <ChatFormAttachmentReply attachments={attachments} />
        </Flex>
        <ButtonIcon
          aria-label="cancel chat reply"
          variant="ghost"
          data-testid="cancel-chat-reply-btn"
          onClick={onCancel}
        >
          <Icon
            name={iconNames.cross}
            height="12px"
            width="12px"
            stroke="var(--fgPrimary)"
          />
        </ButtonIcon>
      </Flex>
      <Spacer size="sm zr" />
    </Flex>
  );
};
